import { DialogContent, Link, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  BottomSheet,
  DialogFooter,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

export interface ChildcareReferralPromptBottomSheetCopy {
  title: string;
  body: string;
  ctaText: string;
}

export interface ChildcareReferralPromptBottomSheetProps {
  modalState: UseModalState;
  onDismiss: () => void;
  onCtaClick: () => void;
  copy: ChildcareReferralPromptBottomSheetCopy;
}

export function ChildcareReferralPromptBottomSheet(props: ChildcareReferralPromptBottomSheetProps) {
  const { modalState, onDismiss, onCtaClick, copy } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={
        <BottomSheetHeader
          onClose={() => {
            onDismiss();
            modalState.closeModal();
          }}
        />
      }
      footer={
        <DialogFooter orientation="vertical" LinkComponent={Link}>
          <LoadingButton
            fullWidth
            isLoading={false}
            variant="contained"
            size="large"
            onClick={() => {
              onCtaClick();
            }}
          >
            {copy.ctaText}
          </LoadingButton>
        </DialogFooter>
      }
      onClose={onDismiss}
    >
      <DialogContent sx={{ backgroundColor: "unset" }}>
        <Stack
          direction="column"
          alignItems="center"
          spacing={7}
          sx={{ textAlign: "center", paddingTop: 2, paddingBottom: 4 }}
        >
          <Illustration type="referral-bonus" />
          <Title component="h2" sx={{ textWrap: "balance" }}>
            {copy.title}
          </Title>
          <Text
            semibold
            variant="body1"
            sx={(theme) => ({ color: theme.palette.text.secondary, textWrap: "pretty" })}
          >
            {copy.body}
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
